<template>
  <div>
    <business-list v-show="tabType === 1" @handleShow="handleShow" />
    <business-show v-if="tabType === 2" :rowItem="rowItem" :activeType="activeType" @handleShow="handleShow" />
  </div>
</template>

<script>
import businessList from './list.vue'
import businessShow from './show.vue'
export default {
  components: { businessList, businessShow },
  data() {
    return {
      tabType: 1,
      rowItem: null,
      activeType: null
    }
  },
  methods: {
    handleShow({ row, activeType }, type) {
      this.tabType = type
      this.rowItem = row
      this.activeType = activeType
    }
  }
}
</script>

<style>
</style>
